import React, { useEffect, useMemo, useState } from 'react';
import { compalAdminNavigationEntrypoint } from '@atlassian/jira-command-palette-admin-navigation/entrypoint.tsx';
import { useCommandPaletteIsOpen } from '@atlassian/jira-command-palette/src/controllers/command-palette/index.tsx';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';

const entryPointParams = {};
export const InitialiseAdminNavCommands = (): React.JSX.Element => {
	const [initialised, setInitialised] = useState(false);
	const { entryPointReferenceSubject, entryPointActions } = useEntryPoint(
		compalAdminNavigationEntrypoint,
		entryPointParams,
	);
	const [{ isOpen }] = useCommandPaletteIsOpen();
	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		// eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
		if (!initialised) return;
		if (isOpen) {
			entryPointActions.load();
		} else {
			entryPointActions.unload();
		}
	}, [isOpen, entryPointActions, initialised]);

	useEffect(() => {
		if (!initialised && isOpen) setInitialised(true);
	}, [isOpen, initialised]);

	const props = useMemo(() => ({}), []);

	return (
		<JiraEntryPointContainer
			entryPointReferenceSubject={entryPointReferenceSubject}
			id="commandPaletteAsyncAdminNavigation"
			packageName="jiraCommandPaletteIntegration"
			teamName="deliveroo"
			fallback={null}
			errorFallback="flag"
			runtimeProps={props}
		/>
	);
};
